import React, { useState, useEffect } from "react";
import Autosuggest from "react-autosuggest";
import { Link } from "react-router-dom";
import { Container, Spinner, Alert } from "react-bootstrap";
import Axios from "axios";
import "./styles/RatingComponent.css";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

function Hero() {
  const [inputValue, setInputValue] = useState(""); // Empty input value initially
  const [suggestions, setSuggestions] = useState([]); // Filtered search suggestions
  const [isInstituteSearch, setIsInstituteSearch] = useState(true); // Default to institute search
  const [loading, setLoading] = useState(false); // Loading state
  const [error, setError] = useState(""); // Error state

  const navigate = useNavigate(); // Hook to handle navigation

  const carouselHeadings = [
    "দেশের প্রথম — University এবং Faculty রিভিউ প্ল্যাটফর্ম।",
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  // Change heading every 3 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % carouselHeadings.length);
    }, 3000);

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  // Function to handle selection of search suggestions
  const onSuggestionSelected = (event, { suggestion }) => {
    if (isInstituteSearch) {
      navigate(`/institute/${suggestion.institute_id}`); // Redirect to Institute Profile
    } else {
      navigate(`/teacher/${suggestion.teacher_id}`); // Redirect to Teacher Profile
    }
  };

  // Handle input change
  const onChange = (event, { newValue }) => {
    setInputValue(newValue);
  };

  // Fetch suggestions from the API (Teacher or Institute)
  const onSuggestionsFetchRequested = async ({ value }) => {
    if (value.length === 0) return setSuggestions([]);

    setLoading(true);
    setError("");

    try {
      let response;
      if (isInstituteSearch) {
        response = await Axios.get(
          "https://server.goatteachers.com/api/institutes/search",
          {
            params: { query: value, limit: 5 },
          },
        );
      } else {
        response = await Axios.get(
          "https://server.goatteachers.com/api/teachers/search",
          {
            params: { query: value, limit: 5 },
          },
        );
      }

      setSuggestions(response.data); // Set fetched results
    } catch (error) {
      console.error("Error fetching suggestions:", error);
      setError(
        `Failed to fetch suggestions: ${
          error.response?.data?.message || error.message
        }`,
      );
    } finally {
      setLoading(false);
    }
  };

  // Clear suggestions when needed
  const onSuggestionsClearRequested = () => {
    setSuggestions([]);
  };

  // Render suggestion component for Teachers
  const renderTeacherSuggestion = (suggestion, { query }) => {
    const parts = suggestion.teacher_name.split(new RegExp(`(${query})`, "gi"));

    return (
      <Link
        to={`/teacher/${suggestion.teacher_id}`}
        className="suggestion-link"
      >
        <div className="suggestion-row">
          <div className="suggestion-title">
            {parts.map((part, index) =>
              part.toLowerCase() === query.toLowerCase() ? (
                <strong key={index}>{part}</strong>
              ) : (
                <span key={index}>{part}</span>
              ),
            )}
          </div>

          {suggestion.institute_name && (
            <div className="suggestion-subtitle">
              {suggestion.institute_name}
            </div>
          )}
        </div>
      </Link>
    );
  };

  // Render suggestion component for Institutes
  const renderInstituteSuggestion = (suggestion, { query }) => {
    const parts = suggestion.institute_name.split(
      new RegExp(`(${query})`, "gi"),
    );

    return (
      <Link
        to={`/institute/${suggestion.institute_id}`} // Redirect to institute profile
        style={{ textDecoration: "none", color: "inherit" }}
      >
        {parts.map((part, index) =>
          part.toLowerCase() === query.toLowerCase() ? (
            <strong key={index} style={{ color: "#007bff" }}>
              {part}
            </strong>
          ) : (
            part
          ),
        )}
      </Link>
    );
  };

  // Handle search type toggle (Institute or Teacher)
  const toggleSearchType = () => {
    setIsInstituteSearch(!isInstituteSearch);
    setInputValue(""); // Clear the search input when toggling
    setSuggestions([]); // Clear current suggestions
    setError(""); // Clear error on toggle
  };

  return (
    <div className="hero-section">
      <Container className="rating-component-container">
        <div className="dsgkja">
          <h1 className="hero-title montserrat-headings fade-text">
            {carouselHeadings[currentIndex]}
          </h1>
        </div>
        {/* <p className="hero-subtitle">
          এখন তোমার সুযোগ ভার্সিটিকে ফ্যাকাল্টিকে Feedback দেয়ার
        </p> */}
        {/* Error handling */}
        {error && <Alert variant="danger">{error}</Alert>}

        {/* Autosuggest Search Bar */}
        <div className="autocomplete-wrapper">
          <Autosuggest
            suggestions={suggestions}
            onSuggestionsFetchRequested={onSuggestionsFetchRequested}
            onSuggestionsClearRequested={onSuggestionsClearRequested}
            onSuggestionSelected={onSuggestionSelected}
            getSuggestionValue={(suggestion) =>
              isInstituteSearch
                ? suggestion.institute_name
                : suggestion.teacher_name
            }
            renderSuggestion={
              isInstituteSearch
                ? renderInstituteSuggestion
                : renderTeacherSuggestion
            }
            inputProps={{
              placeholder: isInstituteSearch
                ? "Search Your University..."
                : "Search Your Faculty...",
              value: inputValue,
              onChange: onChange,
              className: "hero-input",
            }}
          />
        </div>

        {/* Loading spinner */}
        {loading && <Spinner animation="border" />}

        {/* Search Type Toggle */}
        <div className="search-type-toggle">
          <button
            className={`toggle-btn ${isInstituteSearch ? "active" : ""}`}
            onClick={toggleSearchType}
          >
            <span className="toggle-text">
              Search by {isInstituteSearch ? "Faculty Name" : "University Name"}
            </span>
          </button>
        </div>
      </Container>
    </div>
  );
}

export default Hero;
